<template>
    <div class="successful">
        <div style="min-height: 5.6rem;"></div>
        <section class="banner" data-aos="fade-up" data-aos-duration="1000">
            <img  class="hidden-xs-only" src="/imgs/successful/chenggonganli_banner.png" alt="" />
            <img  class="hidden-sm-and-up" src="/imgs/successful/banner_d.png" alt="" />
            <div data-aos="slide-left" data-aos-duration="1000">
                <h1>成功案例</h1>
                <p>规范管理，至诚服务。品质、安全、高效、标准</p>
            </div>
        </section>
        
        <section class="stations" data-aos="fade-up" data-aos-duration="1000">
            <div class="stations-list">
                <div v-for="(item, idx) of stations" :key="'s' + idx" >
                    <div :style="'left:'+item.left+'px;top:'+item.top+'px;transform:scale('+item.scale+');'">
                        <img :src="item.logo" alt="" />
                    </div>
                    <span :style="'left:'+(item.left+20)+'px;top:'+(item.top+120)+'px;'">{{ item.name }}</span>
                </div>
            </div>
            <!-- <div class="stations-list">
                <div v-for="(item, idx) of stations_arr2" :key="'s' + idx" >
                    <div :style="'left:'+item.left+'px;top:'+item.top+'px;transform:scale('+item.scale+');'">
                        <img   :src="item.logo" alt="" />
                    </div>
                    <span :style="'left:'+(item.left+20)+'px;top:'+(item.top+120)+'px;'">{{ item.name }}</span>
                </div>
            </div> -->
        </section>

        <section class="case" data-aos="fade-up" data-aos-duration="1000">
            <div class="case-title">
                <div class="title">
                    <span></span>
                    <h3>成功案例</h3>
                    <p>全国超过200多家采供血单位，在使用傲天产品</p>
                </div>
            </div>
            <div class="case-content">
                <div
                    class="case-content-item"
                    v-for="item of cases"
                    :key="item.id"
                >
                    <div class="case-content-item-cover">
                        <img onerror="this.src='/imgs/queshengye_b.png'" :src="item.coverImg?item.coverImg:'/imgs/queshengye_a.png'" alt="" />
                    </div>
                    <div class="case-content-item-desc">
                        <h3>{{ item.title }}</h3>
                        <span></span>
                        <p>{{ item.briefly }}</p>
                        <div @click="handleDetail(item.id)">
                            <span>了解详情</span>
                            <img  src="" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-pages" v-show="pages>1">
                    <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-size="pageSize"
                    layout="prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </section>
    </div>
</template>
<script>
import {getNews } from "@/utils/api.js";
// import stations from "@/utils/stations.json"
import stations from "@/utils/logo.json"
export default {
    name: "Successful",
    components: {},
    data() {
        return {
            posLeft:0,
            isleft:false,
            stations: [],
            stations_arr1:[],
            stations_arr2:[],
            cases: [],
            page:1,
            pages:0,
            pageSize:6,
            total:0,
        };
    },
    methods: {
        handleDetail(e) {
            this.$router.push("/newsDetail/" + e+"?label=30&nav=Successful");
        },
        GETSsations() {
            const that = this
            const data = stations.data;
            let arr1 = []
            let arr2 = []
            const randomBoolean = () => Math.random() >= 0.5;
            data.forEach((v,index)=>{
                const scale=Number(((Math.random()*3+9)/10).toFixed(2))
                let min =140*scale
                let max =Math.floor(180-(140*scale))
                let left = Math.floor(Math.random()*max-20)
                let top = Math.floor(Math.random()*max-20)
                v.left = Number(left)
                v.top = Number(top)
                v.scale = Number(scale)
                const ran = randomBoolean()
                v.speedX = ran ? Number((Math.random()*2).toFixed(3)) : -Number((Math.random()*2).toFixed(3));
                v.speedY = ran ? Number((Math.random()*2).toFixed(3)) : -Number((Math.random()*2).toFixed(3));
                if(index %2){
                    arr1.push(v)
                }else{
                    arr2.push(v)
                }
            })

            that.stations = data
            that.stations_arr1 = arr1
            that.stations_arr2 = arr2
            // if(!this.timer){
            //     this.timer = setInterval(()=>{
            //         for(let v of data){
            //             let speedX = (Math.random()*2).toFixed(3)
            //             let speedY = (Math.random()*2).toFixed(3)
            //             if(v.speedX>0){
            //                 speedX = -speedX
            //             }
            //             if(v.speedY>0){
            //                 speedY = -speedY
            //             }
            //             v.speedX = Number(speedX)
            //             v.speedY = Number(speedY)
            //             v.left += Number(speedX)
            //             v.top += Number(speedY)
            //         }
                    
            //         that.stations = data
            //     },700)
            // }

        },
        handleCurrentChange(e){
            this.page = e
            this.GETNews()
        },
        GETNews(){
            const params={
                current:this.page,
                size:this.pageSize,
                labelList:'30'
            }
            getNews(params).then(res=>{
                if(res.data.code == 10000){
                    const data = res.data.data
                    this.cases = data.records 
                    this.page = data.current
                    this.pages = data.pages
                    this.total = data.total
                }
            })
        },
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-成功案例"
    },
    mounted() {
        this.GETSsations()
        this.GETNews()
    },
    beforeDestroy(){
        const that = this
        window.clearInterval(that.timer)
    },
    destroyed(){
    }
};
</script>
<style lang="less" scoped>
.successful {
    background: #fafafa;
    max-width: 100vw;
    overflow-x: none;
    .banner {
        width: 100vw;
        position: relative;
        min-height: 25.8rem;
        margin: 0;
        padding: 0;
        img {
            width: calc(100vw + 25px);
            min-height: 25.8rem;
            position: relative;
            z-index: 1;
            object-fit: cover;
        }
        > div {
            width: 100vw;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            color: #fff;
            > h1 {
                font-size: 2.5rem;
                margin-top:10vh;
                margin-right: 10vw;
            }
            > p {
                max-width: 80vw;
                text-align: right;
                font-size: 1.1rem;
                line-height: 1.6rem;
                margin: 0;
                margin-right: 10vw;
            }
        }
    }

    .stations {
        width: 100vw;
        max-width: 100vw;
        height: 500px;
        overflow: hidden;
        background: linear-gradient(
            0deg,
            rgba(15, 69, 249, 0) 0%,
            rgba(15, 69, 249, 0.08) 100%
        );
        margin-top:-1rem;
        padding-top: 4rem;
        position: relative;
        .stations-list {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            height: 400px;
            width: 5600px;
            position: relative;
            -webkit-animation: 250s move infinite linear;
            animation: 250s move infinite linear;
            > div {
                height: 200px;
                width: 200px;
                min-width: 200px;
                position: relative;
                > div {
                    position: absolute;
                    width: 140px;
                    height: 140px;
                    background: #fff;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 12px 0 hsl(0deg 0% 86% / 50%);
                    transition: all 0.5s linear;
                    > img {
                        width: 130px;
                    }
                }
                > span {
                    position: relative;
                    z-index: 2;
                    font-size: 12px;
                    overflow: hidden;
                    color: #666666;
                    background: #fff;
                    padding: 5px 10px;
                    border-radius: 12px;
                    white-space: nowrap;
                    margin-top:130px;
                    opacity: 0;
                    transition: all 0.3s ease;
                    box-shadow: 0 6px 12px 0 hsl(0deg 0% 86% / 50%);
                }
                &:hover{
                    >span{
                        opacity: 1;
                    }
                }
            }
        }
    }
    @-webkit-keyframes move {
        0% {
            left: 0;
        }
        50% {
            left: -5600px;
        }

        100% {
            left: 0;
        }
    }

    @keyframes move {
        0% {
            left: 0;
        }
        50% {
            left: -5600px;;
        }

        100% {
            left: 0;
        }
    }
    
    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        > span {
            display: block;
            width: 5.6rem;
            height: 0.4rem;
            background: #0f45f9;
            margin-bottom: 1rem;
        }
        > p {
            font-size: 1.33rem;
        }
    }
    .case {
        max-width: calc(100vw - 40px);
        width: 67rem;
        margin: 20px auto;
        padding-bottom: 7.7rem;
        .case-title {
            margin-bottom: 3.3rem;
        }
        .case-content {
            .case-content-item {
                width: 100%;
                background: #ffffff;
                box-shadow: 0px 0px 20px 0px rgba(15, 24, 55, 0.1);
                border-radius: 20px;
                margin-bottom: 20px;
                display: flex;
                flex-wrap: wrap;
                overflow: hidden;
                .case-content-item-cover {
                    width: 33.5rem;
                    height: 23.33rem;
                    max-width: 100vw;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .triangle-left {
                        position: absolute;
                        right: -1px;
                        top: 0;
                        width: 0px; /*设置宽高为0，所以div的内容为空，从才能形成三角形尖角*/
                        height: 0px;
                        border-bottom: 23.4rem solid #fff;
                        border-left: 1.67rem solid transparent; /*transparent 表示透明*/
                        // border-right: 0 solid transparent;
                    }
                    .triangle-right {
                        position: absolute;
                        left: -1px;
                        top: 0;
                        width: 0px; /*设置宽高为0，所以div的内容为空，从才能形成三角形尖角*/
                        height: 0px;
                        border-bottom: 23.4rem solid #fff;
                        border-right: 1.67rem solid transparent; /*transparent 表示透明*/
                        // border-right: 0 solid transparent;
                    }
                    img {
                        width: 100%;
                        height: 23.33rem;
                        object-fit: cover;
                        margin: 0;
                        padding: 0;
                        border: none;
                        &:not([src]) {
                            opacity: 0;
                        }
                    }
                }
                .case-content-item-desc {
                    color: #000;
                    width: 33.5rem;
                    max-width: calc(100vw - 40px);
                    > h3 {
                        // white-space: pre-wrap;
                        margin: 2.5rem 4rem 0;
                    }
                    > span {
                        display: block;
                        width: 5rem;
                        height: 0.33rem;
                        background: #0f45f9;
                        margin: 1rem 4rem 0;
                    }
                    > p {
                        margin: 3rem 4rem 4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                        min-height: 4.2rem;
                        font-size: 0.77rem;
                        color: #666666;
                        white-space: pre-wrap;
                    }
                    > div {
                        margin: 0 4rem 2rem;
                        width: 8rem;
                        height: 2.7rem;
                        background: #0f45f9;
                        color: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        opacity: 1;
                        transition: all 0.3s ease;
                        &:hover{
                            opacity: 0.7;
                        }
                    }
                }
                &:nth-child(even){
                    flex-direction: row-reverse;
                }
            }
        }
        .list-pages{
            margin-top:2rem;
            text-align: center;
        }
    }
    
}
</style>
